import { Component, Input, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { MUSIC, TIME_WAIT_RENDER } from '../../helper/constant';
import { DomSanitizer } from '@angular/platform-browser';
import set = Reflect.set;
import { MapService } from '../../services/map.service';

@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent implements OnInit {
    @Input() gameInit = true;
    backGroundStyle: any;
    @Input() showPlayButton = false;

    constructor(
        public platform: Platform,
        private sanitizer: DomSanitizer,
        private mapService: MapService) {
    }

    ngOnInit() {
        this.platform.ready().then(() => {
            if (this.platform.is('ipad') || this.platform.is('tablet')) {
                // console.log('tablet');
                this.backGroundStyle = this.sanitizer.bypassSecurityTrustStyle('background: url("../../../assets/common/sprites/bg-download-4-3.jpg"); background-size: cover;');
            } else {
                // console.log('not tablet');
                this.backGroundStyle = this.sanitizer.bypassSecurityTrustStyle('background: url("../../../assets/common/sprites/bg-download.jpg"); background-size: cover;');
            }
        });
    }

    hideLoading() {
        this.gameInit = false;
        if (!this.mapService.getMusic()) {
            this.mapService.playMusic(MUSIC.main);
        } else {
            if (this.mapService.getSoundIsPlay() !== MUSIC.main) {
                this.mapService.playMusic(MUSIC.main);
            }
        }
    }
}
